import { render, staticRenderFns } from "./PaymentDueDate.vue?vue&type=template&id=6b0c80d4"
import script from "./PaymentDueDate.vue?vue&type=script&lang=js"
export * from "./PaymentDueDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports